var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.286,
    height: 15.957,
    viewBox: "0 0 8.286 15.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M42.669,15.957V8.679h2.442l.366-2.837H42.669V4.03c0-.821.227-1.381,1.406-1.381h1.5V.111A20.355,20.355,0,0,0,43.388,0a3.418,3.418,0,0,0-3.649,3.749V5.841H37.29V8.679h2.449v7.278Z",
    transform: "translate(-37.29)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.675ab20980553ab0116e2112deecddae.svg";
export { ForwardRef as ReactComponent };